<template>

<div class="load-more">
  <Loading size="1.3rem" type="spinner" :color="color" v-if="loadingType == 1"></Loading>
	<div class="loading-text" :style="{color:color}">{{loadingType === 0 ? contentText.contentdown : (loadingType === 1 ? contentText.contentrefresh : contentText.contentnomore)}}</div>
</div>
</template>
<script>
import { Loading } from 'vant';

export default {
  components:{
    Loading
  },
  props: {
  	loadingType: {
  		type: Number,
  		default: 0
  	},
  	showImage: {
  		type: Boolean,
  		default: true
  	},
  	color: {
  		type: String,
  		default: "#777777"
  	},
  	contentText: {
  		type: Object,
  		default:()=>{
          return{
            contentdown: "上拉显示更多",
            contentrefresh: "正在加载...",
            contentnomore: "没有更多数据了"
          }
      }
  		}
  },
  methods: {

  }
}
</script>

<style lang="less">
	.load-more {
		display: flex;
		flex-direction: row;
		height: 2.4rem;
		align-items: center;
		justify-content: center;
		
		.loading-img {
			height: 24px;
			width: 24px;
			margin-right: 10px;
		}
		
		.loading-text {
			font-size: 0.8rem;
		margin-left: 0.3rem;
		}
		
		.loading-img>div {
			position: absolute;
		bottom: 8px;
		}
		
		.loading-load1,
		.loading-load2,
		.loading-load3 {
			height: 24px;
			width: 24px;
		}
		
		.loading-load2 {
			transform: rotate(30deg);
		}
		
		.loading-load3 {
			transform: rotate(60deg);
		}
		
		.loading-img>div div {
			width: 6px;
			height: 2px;
			border-top-left-radius: 1px;
			border-bottom-left-radius: 1px;
			background: #777;
			position: absolute;
			opacity: 0.2;
			transform-origin: 50%;
			-webkit-animation: load 1.56s ease infinite;
		}
		
		.loading-img>div div:nth-child(1) {
			transform: rotate(90deg);
			top: 2px;
			left: 9px;
		}
		
		.loading-img>div div:nth-child(2) {
			-webkit-transform: rotate(180deg);
			top: 11px;
			right: 0px;
		}
		
		.loading-img>div div:nth-child(3) {
			transform: rotate(270deg);
			bottom: 2px;
			left: 9px;
		}
		
		.loading-img>div div:nth-child(4) {
			top: 11px;
			left: 0px;
		}
		
		.loading-load1 div:nth-child(1) {
			animation-delay: 0s;
		}
		
		.loading-load2 div:nth-child(1) {
			animation-delay: 0.13s;
		}
		
		.loading-load3 div:nth-child(1) {
			animation-delay: 0.26s;
		}
		
		.loading-load1 div:nth-child(2) {
			animation-delay: 0.39s;
		}
		
		.loading-load2 div:nth-child(2) {
			animation-delay: 0.52s;
		}
		
		.loading-load3 div:nth-child(2) {
			animation-delay: 0.65s;
		}
		
		.loading-load1 div:nth-child(3) {
			animation-delay: 0.78s;
		}
		
		.loading-load2 div:nth-child(3) {
			animation-delay: 0.91s;
		}
		
		.loading-load3 div:nth-child(3) {
			animation-delay: 1.04s;
		}
		
		.loading-load1 div:nth-child(4) {
			animation-delay: 1.17s;
		}
		
		.loading-load2 div:nth-child(4) {
			animation-delay: 1.30s;
		}
		
		.loading-load3 div:nth-child(4) {
			animation-delay: 1.43s;
		}
		
		@-webkit-keyframes load {
			0% {
				opacity: 1;
			}
		
			100% {
				opacity: 0.2;
			}
		}
	}

</style>
